const APP_VERSION = '1781198974447';
export default APP_VERSION;
